import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var ContextMenuResourceAmount = React.memo(function (_a) {
    var baseAmount = _a.baseAmount, buffAmount = _a.buffAmount;
    return (React.createElement("div", null,
        React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: baseAmount }),
        React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: buffAmount || 0, format: TypeNumberFormat.AddExceptZero })));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuResourceAmount.tsx
// module id = 874
// module chunks = 3